import React from 'react';
import {ClickableFormOption} from '../../ClickableFormStructure';

function RawSingleCheckBox({id, label, value, checked, onChange, disabled}) {
    return (
        <ClickableFormOption htmlFor={id} label={label} checkbox disabled={disabled}>
            <input disabled={disabled} id={id} value={value} type="checkbox" checked={checked} onChange={onChange} />
        </ClickableFormOption>
    );
}

export {RawSingleCheckBox};
